import ToolbarService, { TOOLBAR_SECTIONS } from './ToolbarService';
export default ToolbarService;
export { TOOLBAR_SECTIONS };
